import React from 'react';
import { func, string } from 'prop-types';

const PhotosTab = ({ srcIcon, action, altName, containerClass, innerClass }) => {
  return (
    <li className={containerClass} onClick={action}>
      <img alt={altName} className={innerClass} src={srcIcon} />
    </li>
  );
};

PhotosTab.propTypes = {
  srcIcon: string.isRequired,
  action: func.isRequired,
  altName: string.isRequired,
  containerClass: string,
  innerClass: string
};

PhotosTab.defaultProps = {
  containerClass: '',
  innerClass: ''
};

export default PhotosTab;
